(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
(() => {
  let frame = 0;

  function equalizeCards() {
    frame = 0;
    for (const slider of document.querySelectorAll('.bee-testimonial-carousel-equal')) {
      const cards = [...slider.querySelectorAll('.bee-testimonial-wrap')];
      if (!cards.length) continue;

      slider.style.removeProperty('--bee-testimonial-card-height');
      slider.style.removeProperty('--bee-testimonial-slide-height');
      const cardHeight = Math.max(...cards.map(card => Math.ceil(card.getBoundingClientRect().height)));
      if (!cardHeight) continue;

      slider.style.setProperty('--bee-testimonial-card-height', `${cardHeight}px`);
      const slides = [...slider.querySelectorAll('.bee-testimonial-item')];
      const slideHeight = Math.max(...slides.map(slide => Math.ceil(slide.getBoundingClientRect().height)));
      if (slideHeight) slider.style.setProperty('--bee-testimonial-slide-height', `${slideHeight}px`);
    }
  }

  function scheduleEqualize() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(equalizeCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEqualize, { once: true });
  } else {
    scheduleEqualize();
  }
  window.addEventListener('load', scheduleEqualize);
  window.addEventListener('resize', scheduleEqualize);
  document.addEventListener('shopify:section:load', scheduleEqualize);
  document.addEventListener('load', event => {
    if (event.target.closest?.('.bee-testimonial-carousel-equal')) scheduleEqualize();
  }, true);
  document.fonts?.ready.then(scheduleEqualize);
})();

  } catch(e) { console.error(e); }
})();
})();
